import './index.less'
import { VideoPlayer,isMobile } from '@utils/index'

$(function () {
  document.querySelectorAll('.pdp-three-text-img').forEach(item => {
    if (item.dataset.playVideoByOrder === 'true') {
      // 初始化视频播放器
      const videoPlayer = new VideoPlayer({
        container: item,
        videoSelector: 'jky-video',
        onTrack: null, // 数据埋码
      })

      // 初始化视频点击事件并观察视口
      videoPlayer?.init()?.observe()
    }
  })
})

class QualitySwiper {
  constructor() {
    const threeSwiper = $('.keyword-three-text-img');
    this.space = Number(threeSwiper.attr("data-space")) || 24
    this.slidesPerView = Number(threeSwiper.attr("data-slidesPerView")) || 1.3
    threeSwiper.attr('data-swiper') == 'true' && isMobile() && this.init()
  }
  init() {
      const that = this
      const qualityIntroSwiper = $('.pdp-three-text-img');
        if (qualityIntroSwiper.length === 0) return;
        qualityIntroSwiper.each(function() {
            const className = $(this).attr('class');
            const match = className.match(/pdp-three-text-img-(\S+)/);
            const index = match ? match[1] : $(this).data('index');
            const currentComponent = `.pdp-three-text-img-${index}`;
            const currentSwiper =  $(`${currentComponent} .quality-introduction-swiper`);

            new Swiper(currentSwiper[0], {
                spaceBetween: that.space,
                slidesPerView: that.slidesPerView,
                slideToClickedSlide: true,
                autoplay: false,
                freeMode: false,
                loop: true,
                lazy: true,
                navigation: {
                    prevEl: `.quality-introduction-${index} .swiper-activity-button-prev`,
                    nextEl: `.quality-introduction-${index} .swiper-activity-button-next`
                },
                pagination: {
                    el: `${currentComponent} .quality-pagination`,
                    clickable: true
                }
            });
        })
  }
}

new QualitySwiper()


